import {
  CREATE_MEDIA_PLAN_DRAFT,
  TRIGGER_MEDIA_PLAN_MODEL_TRAINING,
} from "@gql/mmm-media-plan";
import { useNorthbeamMutation } from "@hooks/http";
import {
  type CreateMediaPlanDraft,
  type CreateMediaPlanDraftVariables,
  type TriggerMediaPlanModelTrainingVariables,
  type TriggerMediaPlanModelTraining,
} from "@north-beam/nb-client-side/nb-api-graphql-generated";

import { useSelectedMediaPlanModal } from "../create-media-plan-modal/use-selected-media-plan-modal";

import { useMediaPlanData } from "./use-media-plan";

export const useCreateMediaPlan = () => {
  const { setMediaPlanList } = useMediaPlanData();
  const { setSelectedMediaPlanId } = useSelectedMediaPlanModal();
  const [createMediaPlan, { loading: isCreateMediaPlanLoading }] =
    useNorthbeamMutation<CreateMediaPlanDraft, CreateMediaPlanDraftVariables>(
      CREATE_MEDIA_PLAN_DRAFT,
      {
        update: (_cache, { data }) => {
          if (data) {
            setMediaPlanList((prevMediaPlanList) => {
              if (data?.createMediaPlanDraft.id) {
                return [data.createMediaPlanDraft, ...prevMediaPlanList];
              }
              return prevMediaPlanList;
            });

            setSelectedMediaPlanId((prevSelectedMediaPlanId) => {
              if (
                data?.createMediaPlanDraft.id &&
                prevSelectedMediaPlanId !== data?.createMediaPlanDraft.id
              ) {
                return data.createMediaPlanDraft.id;
              }
              return prevSelectedMediaPlanId;
            });
          }
        },
      },
    );

  return { createMediaPlan, isCreateMediaPlanLoading };
};

export const useMediaPlanTriggerModelTraining = () => {
  const [triggerModelTraining, { loading: isTriggerModelTrainingLoading }] =
    useNorthbeamMutation<
      TriggerMediaPlanModelTraining,
      TriggerMediaPlanModelTrainingVariables
    >(TRIGGER_MEDIA_PLAN_MODEL_TRAINING, {
      update: (cache, { data }) => {
        if (data) {
          cache.modify({
            id: cache.identify({
              __typename: "mmmMediaPlan",
              id: data.triggerOptimizerModelTraining.cycle_id,
            }),
            fields: {
              state: () => "blessing_model",
            },
          });
        }
      },
    });

  return { triggerModelTraining, isTriggerModelTrainingLoading };
};
